/**
 * Data slider
 */
(function($) {
  "use strict";

  $(window).ready(slickify);

  // Constants
  var logoSlider = ".field--name-field-image-droite-media";

  /**
   * Init
   */
  function slickify() {
    $(logoSlider).not('.slick-initialized').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      initialSlide: 0,
      vertical: true,
      dots: false,
      arrows: true,
      centerMode: false,
      adaptiveHeight: true
    });
  }

})(jQuery);